import { NgModule } from '@angular/core';
import { NullWithDefaultPipe } from 'src/app/shared/pipes/null-with-default.pipe';
import { TransformToDecimalPipe } from 'src/app/shared/pipes/transform-to-decimal.pipe';
import { AsiaDatePipe } from '../pipes/asia-date.pipe';

@NgModule({
  declarations: [NullWithDefaultPipe, TransformToDecimalPipe, AsiaDatePipe],
  exports: [NullWithDefaultPipe, TransformToDecimalPipe, AsiaDatePipe],
})
export class SharedPipeModule {}
